import { createSlice } from "@reduxjs/toolkit";
import { AddMemory, UpdateMemory, GetMemoryList } from "services/other/memory.service";
import { toast } from 'react-toastify';

export const memoryAddSlice = createSlice({
  name: "memoryAdd",
  initialState: {
    memoryAdd: {},
    memoryAddLoading: false,
    memoryAddError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(AddMemory.pending, (state) => {
      // toast.loading('We are adding the memory 🤯')
      state.memoryAddLoading = true
    });

    builder.addCase(AddMemory.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('New memory added successfully 👌');

      state.memoryAdd = action.payload
      state.memoryAddLoading = false
      state.memoryAddError = null
    });

    builder.addCase(AddMemory.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the memory 😣")

      state.memoryAddLoading = false
      state.memoryAddError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export const memoryUpdateSlice = createSlice({
  name: "memoryUpdate",
  initialState: {
    memoryUpdate: {},
    memoryUpdateLoading: false,
    memoryUpdateError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(UpdateMemory.pending, (state) => {
      // toast.loading('We are updating the memory 🤯')
      state.memoryUpdateLoading = true
    });

    builder.addCase(UpdateMemory.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Category update successfully 👌');

      state.memoryUpdate = action.payload
      state.memoryUpdateLoading = false
      state.memoryUpdateError = null
    });

    builder.addCase(UpdateMemory.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't update the memory 😣")

      state.memoryUpdateLoading = false
      state.memoryUpdateError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});



export const memoryListSlice = createSlice({
  name: "memoryList",
  initialState: {
    memoryList: [],
    memoryListLoading: false,
    memoryListError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetMemoryList.pending, (state) => {
      state.memoryListLoading = true
    });

    builder.addCase(GetMemoryList.fulfilled, (state, action) => {
      toast.dismiss();

      state.memoryList = action.payload
      state.memoryListLoading = false
      state.memoryListError = null
    });

    builder.addCase(GetMemoryList.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the memory 😣")

      state.memoryListLoading = false
      state.memoryListError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});